var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('WebHeader'),_c('router-view',{key:_vm.$route.path}),_c('WebFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }